// Word-boundary regexes are compiled once and cached. The matcher runs many
// times per second — on every interim speech result, across every command group
// (and every visible drawing name on the home page) — so reusing the compiled
// regexes keeps the hot path cheap and the voice response low-latency.
const reCache = new Map<string, RegExp>();

function wordRegex(word: string): RegExp {
  let re = reCache.get(word);
  if (re === undefined) {
    const esc = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // NOT `\b`: JavaScript's word boundary is ASCII-only, so `\brègles\b` never
    // matches (è isn't a `\w` character) and neither would any Greek or
    // Cyrillic word. Unicode-aware lookarounds give a real boundary in every
    // language. `speakable()` already relies on lookbehind, so the browser
    // baseline supports it.
    re = new RegExp(`(?<![\\p{L}\\p{N}])${esc}(?![\\p{L}\\p{N}])`, "u");
    reCache.set(word, re);
  }
  return re;
}

/** True if any of `words` appears as a whole word in the transcript. */
export function heardAny(transcript: string, words: string[]): boolean {
  for (let i = 0; i < words.length; i++) {
    if (wordRegex(words[i]).test(transcript)) return true;
  }
  return false;
}
